module.exports = __webpack_public_path__ + "img/unishark_kiwi_lychee.b89c1290.png";